import { Guid } from '@web/utils';
import { PublicSales } from '@web/shared/module/shop';

export class PublicBox {
  public constructor(
    private readonly data: {
      id: Guid;
      slug: string;
      name: string;
      publishedAt: Date;
      imageAlt: string;
      imageSrc: string;
      rating: number;
      sales: PublicSales;
      votes: number;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get name(): string {
    return this.data.name;
  }

  public get publishedAt(): Date {
    return this.data.publishedAt;
  }

  public get imageAlt(): string {
    return this.data.imageAlt;
  }

  public get imageSrc(): string {
    return this.data.imageSrc;
  }

  public get rating(): number {
    return this.data.rating;
  }

  public get sales(): PublicSales {
    return this.data.sales;
  }

  public get votes(): number {
    return this.data.votes;
  }
}
